'use client'

import { useEffect, Suspense } from 'react'
import { usePostHog } from 'posthog-js/react'

import { useAuth, useUser } from '@clerk/nextjs'
import { useTimezoneSync } from '@/hooks/useTimezoneSync'

// https://clerk.com/blog/how-to-use-clerk-with-posthog-identify-in-nextjs
function PostHogPageView(): null {
  const posthog = usePostHog()

  const { isSignedIn, userId } = useAuth()
  const { user } = useUser()

  // Sync user timezone for daily email scheduling
  useTimezoneSync()

  useEffect(() => {
    if (isSignedIn && userId && user && !posthog._isIdentified()) {
      posthog.identify(userId, {
        email: user.primaryEmailAddress?.emailAddress,
        username: user.username,
      })
    }
  }, [posthog, isSignedIn, userId, user])

  return null
}
export default function Wrapped() {
  return (
    <Suspense>
      <PostHogPageView />
    </Suspense>
  )
}
